import React, { Component, createRef } from 'react'
import { injectIntl } from 'react-intl'
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Checkbox,
  ListItemText,
  Typography,
  Popover,
} from '@material-ui/core'
import PropType from 'prop-types'
import { isEqual, isEmpty } from 'lodash'
import ArrowIcon from '@material-ui/icons/ArrowDropDown'
import CircularProgress from '@material-ui/core/CircularProgress'
import messages from './translate'

export const ALL_SELECTED = 'allSelected'

class SensorMultiSelect extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value,
      allSelected: true,
      openPopover: null,
    }

    this.popoverRef = createRef()
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props
    const { value: prevValue } = prevProps

    if (!isEqual(value, prevValue)) {
      this.setState({ value }, () => this.checkItemsSelected())
    }
  }

  findElement = (arr, id, typeId) =>
    arr.find(item => item.type_id === Number(typeId) && item.id === Number(id))

  onChangeValue = event => {
    const { selectedItemsLimit } = this.props
    const { value: values } = this.state
    const { value } = event.target
    const { currentTarget } = event
    const popoverRef = this.popoverRef && this.popoverRef.current
    const {
      dataset: { id, typeId, checkAll },
    } = currentTarget
    let checkObj
    let existItem
    let newArr = []
    let resArr = []

    if (selectedItemsLimit && currentTarget === popoverRef) return

    if (checkAll === ALL_SELECTED) {
      this.allItemsSelected()

      return
    }

    if (!isEmpty(values)) {
      newArr = [...values]

      existItem = this.findElement(newArr, id, typeId)
      checkObj = existItem && Object.keys(existItem)
    }

    if (!isEmpty(checkObj)) {
      resArr = newArr.filter(({ name }) => name !== existItem.name)
    } else {
      resArr = [...resArr, ...value]
    }

    if (
      selectedItemsLimit &&
      !isEmpty(resArr) &&
      resArr.length > selectedItemsLimit
    ) {
      this.setState({ openPopover: currentTarget })

      return
    }

    this.setState({ value: resArr }, () => this.checkItemsSelected())
  }

  checkItemsSelected = () => {
    const { value, allSelected } = this.state
    const { data, selectedItemsLimit } = this.props
    const dataAllSelected = value.length === data.length
    const allSelectedLimit =
      selectedItemsLimit && value.length === selectedItemsLimit
    let newAllSelectedValue = false

    if (allSelectedLimit || dataAllSelected) {
      newAllSelectedValue = true
    }

    if (newAllSelectedValue !== allSelected) {
      this.setState({ allSelected: newAllSelectedValue })
    }
  }

  checkDataLimits = (data, limit) =>
    data && data.length > limit ? data.slice(0, limit) : data

  allItemsSelected = () => {
    const { allSelected } = this.state
    const { data, selectedItemsLimit } = this.props
    let newData = [...data]

    if (selectedItemsLimit) {
      newData = this.checkDataLimits(newData, selectedItemsLimit)
    }

    this.setState({
      value: allSelected ? [] : newData,
      allSelected: !allSelected,
    })
  }

  getRenderValue = () => {
    const { allSelected, value } = this.state
    const {
      intl: { formatMessage },
    } = this.props
    const sortedArr = value.sort((a, b) => a.count - b.count)

    if (allSelected) {
      return formatMessage(messages.allSelected)
    }

    if (value.length === 0) {
      return null
    }

    return sortedArr.map(item => item.name).join(', ')
  }

  showRightIcon = () => {
    const { loader, SelectIcon } = this.props
    const checkIcon = !SelectIcon ? <ArrowIcon /> : <SelectIcon />

    return (
      <span className="select-loader">
        {loader ? <CircularProgress size={20} /> : checkIcon}
      </span>
    )
  }

  isSelected(item) {
    const { value } = this.state

    return value.some(({ name }) => name === item.name)
  }

  handlePopoverClose = e => {
    e.stopPropagation()
    this.setState({ openPopover: null })
  }

  render() {
    const {
      name,
      label,
      disabled,
      disabledItem,
      data,
      autoWidth,
      meta,
      input,
      MenuProps,
      onClose,
      disableUnderline,
      selectedItemsLimit,
      intl: { formatMessage },
    } = this.props
    const { openPopover, allSelected, value } = this.state
    const isOpenPopover = Boolean(openPopover)

    return (
      <FormControl
        fullWidth
        component="div"
        className="select-filter multi-select">
        <InputLabel>{label}</InputLabel>
        <Select
          multiple
          meta={meta}
          input={input}
          id={name}
          name={name}
          disabled={disabled}
          autoWidth={autoWidth}
          value={value}
          onChange={this.onChangeValue}
          onClose={() => onClose(value)}
          renderValue={this.getRenderValue}
          IconComponent={this.showRightIcon}
          disableUnderline={disableUnderline}
          MenuProps={MenuProps}>
          <MenuItem
            className="multi-select-item"
            disabled={disabledItem}
            data-check-all="allSelected">
            <Checkbox href={null} color="primary" checked={allSelected} />
            <ListItemText
              data-name="allSelected"
              primary={formatMessage(messages.allSelected)}
            />
          </MenuItem>
          {data.map(item => (
            <MenuItem
              key={`${item.name}-${item.id}`}
              className="multi-select-item all-selected"
              disabled={disabledItem}
              value={item}
              data-id={item.id}
              data-type-id={item.type_id}>
              <Checkbox
                href={null}
                color="primary"
                checked={this.isSelected(item)}
              />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
          {selectedItemsLimit && (
            <Popover
              ref={isOpenPopover ? this.popoverRef : null}
              open={isOpenPopover}
              anchorEl={openPopover}
              onClose={this.handlePopoverClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}>
              <Typography className="multi-select-item-limit-label">
                {formatMessage(messages.listLimitMessage, { amount: 20 })}
              </Typography>
            </Popover>
          )}
        </Select>
      </FormControl>
    )
  }
}

export default injectIntl(SensorMultiSelect)

SensorMultiSelect.defaultProps = {
  value: [],
  data: [],
  label: '',
}

SensorMultiSelect.propTypes = {
  name: PropType.string.isRequired,
  data: PropType.array,
  value: PropType.array,
  label: PropType.string,
  selectedItemsLimit: PropType.number,
}
